import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from '@mui/material/Box'
import './Project.css';
import vc from '../../Assets/Projects/videochat.png';
import vcsv from '../../Assets/Projects/videochatSV.gif';
import vc2 from '../../Assets/Projects/VideoChatI2.png';
import visualidentityvc from '../../Assets/Projects/visualidentityvc.png';
import vci1 from '../../Assets/Projects/videochatI1-gif.gif';
import vc5 from '../../Assets/Projects/VideoChatI33.png';
import login from '../../Assets/Projects/VideoChatSignUp.png';
import period from '../../Assets/period.svg';
import {Link} from 'react-router-dom';
import NavBar from "../Navbar";
import Footer from "../Footer";

function VideoChat() {
  return (
    <section>
      <NavBar />
      <Box className="filebox">

            <Row>
            <aside>
              <Col sm={1}>
                <Container style={{ height: '100%' }}>
                
            <div direction="right" className="side-banner">
              <div className="marquee">
              <div className="marquee-content" style={{animationDuration: '80s' }}>
              Video Chat App          Video Chat App          Video Chat App           Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App         Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App         Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App         Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App         Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App         Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          Video Chat App          
                </div>
                </div>
                </div>
                </Container>
              </Col>
              <Col sm={10} className="canteen-ui" style={{ paddingLeft: '130px', paddingRight: '70px' }}>
              <Container fluid className="project-section">
          <Container  className="canteen-content">
                <Row className="first-img" style={{ justifyContent: "center", paddingTop: '40px', paddingBottom: "40px" }}>

                <img
                      src={vc}
                      alt="ecanteen"
                      className="img-fluid"
                      style={{marginBottom: '30px', padding: '0px', border: '1px solid white'}}
                    />
                  </Row>
                  <Row style={{paddingBottom: "40px"}}>
                  <div style={{display:'flex'}}>
                  <h1>Video Chat App for ASD
                  <img
                    src={period}
                    alt="period"
                    className="img-fluid"
                    style={{marginLeft: '2px', paddingTop: '2.5%', }}
                  />
                  </h1>
                  
                  </div>
                  <p className="content">Communication is a significant challenge for those suffering from Autistic Spectrum Disorder (ASD). To address this issue, we developed a<b className="content-bold"> video chat app to help autistic people understand others' emotions.</b> Additionally, <b className="content-bold">to communicate their ideas without social fear, a graphical keyboard was provided.</b></p>
                  <p className="content">Special thanks to the principal, Mrs Akanksha Ranade, the teachers and students at Anandi School, Vile Parle East.</p>
                </Row>
                <Row style={{paddingBottom: "56px", fontFamily: 'Changa', fontSize: '1.2em'}} >
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">MY ROLE</p>
                    <p className="box-p">UI/UX Designer, Frontend Developer</p>
                    </div>
                    </Col>
                    
                    
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TEAM</p>
                    <p className="box-p">3 members - Aditi Deo, Hetvi Jain, Devanshi Jhaveri</p>
                    </div>
                    </Col>
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TOOLS USED</p>
                    <p className="box-p">Figma, React, Django</p>
                    </div>
                    </Col>
                    {/* <Col className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="content">PUBLICATIONS</p>
                    <p className="content">Figma, HTML/CSS, Django, Firebase, Flutter</p>
                    </div>
                    </Col> */}
                </Row>
                <Row style={{paddingBottom: "40px"}}>
                    <Col>
                    <hr></hr>
                    <Row>
                    <div style={{display:'flex'}}>
                      <h2> THE BRIEF</h2> 
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    </Row>
                    <h5>OVERVIEW</h5>
                    <p className="content">Required to select a problem and develop a project for our final year at DJSCE. Before implementing our project, we conducted extensive user research, examined relevant literature, and analysed existing systems over the course of two semesters.</p>
                    </Col>
                </Row>
                {/* <Row style={{paddingBottom: "40px", }}>
                <img
                      src={process}
                      alt="process"
                      className="img-fluid"
                      style={{ maxHeight: "300px" }}
                    />
                    </Row> */}
                
                    <Row style={{paddingBottom: "40px"}}>
                    <Col>
                    <hr></hr>
                    <div  style={{display: 'flex'}}>
                      <h2 style={{display: 'flex'}}> MY CONTRIBUTION</h2> 
                      <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{ justifyItems: 'start', margin: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">01</p>
                      </Col>
                      <Col>
                      <p className="content">Extensively <b className="content-bold">researched Autism Spectrum Disorder(ASD) lifestyles and challenges.</b> It guided my design decisions and ensured the product met this user group's needs.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">02</p>
                      </Col>
                      <Col>
                      <p className="content"><b className="content-bold">Designed and developed the user interface</b>, iterating until it was visually beautiful and easy to use. <b className="content-bold">Stakeholder feedback and user testing</b> ensured that the interface fulfilled project goals and was intuitive for the intended audience.</p>
                      </Col>
                    </Row>
                    {/* <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="content">03</p>
                      </Col>
                      <Col>
                      <p className="content">Precisely tried to match the design to the final output using Bootstrap and CSS. This attention to detail helped generate a polished product that fulfilled user needs and exceeded project expectations.</p>
                      </Col>
                    </Row> */}
                    
                    </Col>
                </Row>

                <Row style={{paddingBottom:"32px"}}>
                  <Col>
                    
                    <hr></hr>
                    <div style={{display: 'flex'}}>
                    <h2>HIGH FIDELITY DESIGNS
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '3%', verticalAlign: 'bottom' }}
                    /></h2>
                    </div>
                    <h4>VISUAL IDENTITY:</h4>
                    <img
                      src={visualidentityvc}
                      alt="visual identity"
                      className="img-fluid"
                      style={{ maxHeight: "400px", paddingBottom: "64px" }}

                    />
                    <h4>FIRST ITERATION:</h4>
                    <p className="content">The first version of the product was created to <b className="content-bold">evaluate the concept</b>. To determine whether the solution was genuinely beneficial to the users.</p>
                    <img
                      src={vci1}
                      alt="period"
                      className="img-fluid"
                      style={{alignItems:'start', justifyItems: 'left', paddingLeft: '0px', marginLeft: '0px', paddingBottom: '16px'}}
                    />
                    <h5>USER FEEDBACK</h5>
                    <p className="content">Many students refused to use the graphical keyboard because they <b className="content-bold">couldn't concentrate on the emoticons and text.</b> Additionally, they had <b className="content-bold">difficulty sharing or joining a call.</b></p>
                    
                    <h4 style={{paddingTop: '40px'}}>SECOND ITERATION:</h4>
                    <p className="content">The <b className="content-bold">icon and font sizes were increased</b> in this version. Furthermore, the process of <b className="content-bold">sharing and joining the meet was simplified.</b></p>
                    <img
                      src={vc2}
                      alt="period"
                      className="img-fluid"
                      style={{alignItems:'start', justifyItems: 'left', paddingLeft: '0px', marginLeft: '0px', paddingBottom: '16px'}}
                    />
                    <h5>USER FEEDBACK</h5>
                    <p className="content">Received <b className="content-bold">positive feedback</b> from users, but a <b className="content-bold">problem arose when more than two individuals participated</b> in the same video chat.</p>
                    
                    <h4 style={{paddingTop: '40px'}}>FINAL DESIGN:</h4>
                    <p className="content">Adapted to the popular user interface of Google Meet and added our proposed features.</p>
                    {/* <img
                      src={vc3}
                      alt="period"
                      className="img-fluid"
                      style={{alignItems:'start', justifyItems: 'left', paddingLeft: '0px', marginLeft: '0px', paddingBottom: '8%'}}
                    /> */}
                    <img
                      src={login}
                      alt="period"
                      className="img-fluid"
                      style={{alignItems:'start', justifyItems: 'left', paddingLeft: '0px', marginLeft: '0px', paddingBottom: '24px'}}
                    />
                    <img
                      src={vcsv}
                      alt="period"
                      className="img-fluid"
                      style={{alignItems:'start', justifyItems: 'left', paddingLeft: '0px', marginLeft: '0px', paddingBottom: '24px'}}
                    />
                    
                    <img
                      src={vc5}
                      alt="period"
                      className="img-fluid"
                      style={{alignItems:'start', justifyItems: 'left', paddingLeft: '0px', marginLeft: '0px', paddingBottom: '16px'}}
                    />
                    <h5>USER FEEDBACK</h5>
                    <p className="content"><b className="content-bold">Everyone involved was pleased with the end result.</b> Since we tried it at an autistic school, the principal and teachers agreed that if they ever had to do school online again, it would be really advantageous.</p>
                    
                    
                  </Col>
                </Row>

                <Row style={{marginBottom: "100px", paddingTop:"32px", fontFamily: 'Changa', fontSize: '1.2em'}}>
                  <Link to={'/project/healthpredictor'} style={{textDecoration: 'none'}}>
                    <div className="button-work" style={{border: "1px solid white",borderRadius:'5px', height: 'auto', width: '15%',color:'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom:'10px', position: 'absolute'}}>
                    Previous
                    </div>
                  </Link>
                </Row> 

                </Container>
        </Container>
              </Col>
              </aside>
            </Row>
         
        <Footer />
      </Box>
    </section>
  );
}

export default VideoChat;
